import { CountryCode } from '@/constants/countryCodes';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';

export const IOF_DISCLAIMER_PT_KEY = 'IOFDisclaimer_pt';

/**
 * Brazil IOF line (ACDEV-29689). `countryCode` is the resolved checkout
 * country (`taxCountry`, then `geoLocator`). Hidden only for Stripe Pix,
 * which already shows its own disclaimer inside the Payment Element.
 */
export const shouldShowIOFDisclaimer = (
  countryCode: string | undefined,
  paymentMethod: PaymentMethodEnum | undefined,
  provider?: string
): boolean => {
  if (!countryCode || !paymentMethod) return false;
  if (countryCode.toUpperCase() !== CountryCode.BRAZIL) return false;
  return !(paymentMethod === PaymentMethodEnum.PIX && provider === ProviderEnum.STRIPE);
};
